import React from "react";
import { ModalHeader } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalHeader";
import { ModalBody } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalBody";
import TokenTransferStep, {
  TokenTransferStepProps,
} from "../../TokenTransferStep";
import { Body5 } from "@/src/components/typography/components/Body";
import { LoadingOrdersView } from "@/app/(main)/account/orders/components/UserHasNoOrdersView/components/LoadingOrdersView";

export default function TransferPending({
  isShowing = false,
}: TokenTransferStepProps) {
  return (
    <TokenTransferStep isShowing={isShowing}>
      <ModalHeader>Transferring...</ModalHeader>

      <ModalBody className="flex flex-col gap-6">
        <BodyCopy />
        <LoadingOrdersView className="h-32 w-32 text-md mix-blend-lighten" />
      </ModalBody>
    </TokenTransferStep>
  );
}

function BodyCopy() {
  return (
    <Body5>
      Your transfer is in progress! Please do not close out this window. This
      process can take up to a few minutes.
    </Body5>
  );
}
